/**
 *  @class
 *  @function BackToTop
 *  Shows its button once the page has scrolled a screen down; until then it is inert. From the keyboard,
 *  focus goes to the first link of the page, where the scroll ends.
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {

		connectedCallback() {
			this.ticking = false;
			this._onScroll = this.checkVisible.bind(this);
			this._onResize = () => { this.pageHeight = window.innerHeight; };

			this.pageHeight = window.innerHeight;

			this.querySelector('button')?.addEventListener('click', this.onClick);
			window.addEventListener('scroll', this._onScroll, { passive: true });
			window.addEventListener('resize', this._onResize, { passive: true });
			this.checkVisible();
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this._onScroll);
			window.removeEventListener('resize', this._onResize);
		}

		checkVisible() {
			if (this.ticking) return;
			this.ticking = true;
			window.requestAnimationFrame(() => {
				const active = window.scrollY > this.pageHeight;
				this.classList.toggle('back-to-top--active', active);
				this.inert = !active;
				this.ticking = false;
			});
		}

		onClick(event) {
			const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
			// A keyboard press (no pointer: detail 0) continues from the top of the page.
			if (event.detail === 0) document.querySelector('.screen-reader-shortcut')?.focus({ preventScroll: true });
		}
	}
	customElements.define('back-to-top', BackToTop);
}
